import React from 'react';
import ErrorPage404 from "../../images/page404.svg";
import {useNavigate} from "react-router-dom";

const Page404 = () => {
    let navigate = useNavigate();
    const goBack = () => navigate("/")
    return (
        <>
            <div className={"container-fluid text-center error-page"}>
                <div className={"row pt-5"}>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 pt-5 error-page-image bcg-white"}>
                        <img src={ErrorPage404}/>
                    </div>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 error-page-number bcg-white"}>
                        <span>404</span>
                    </div>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 error-page-message bcg-white"}>
                        <p>Dokument nije pronađen. Resurs koji tražite nije više dostupan na ovom serveru.</p>
                    </div>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 error-page-message bcg-white"}>
                        <button className={"btn btn-back"} onClick={goBack}>Vrati se na početnu</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page404;
